var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 136,
    viewBox: "0 0 188 136",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_97894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177 0H21C14.9249 0 10 4.91295 10 10.9734V115.051C10 121.111 14.9249 126.024 21 126.024H177C183.075 126.024 188 121.111 188 115.051V10.9734C188 4.91295 183.075 0 177 0Z",
    fill: "#A5D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.1018H178V125.037C178 126.478 177.715 127.905 177.163 129.236C176.61 130.567 175.8 131.777 174.778 132.796C173.757 133.815 172.544 134.623 171.21 135.175C169.875 135.726 168.445 136.01 167 136.01H11C8.08262 136.01 5.28473 134.854 3.22183 132.796C1.15893 130.738 0 127.947 0 125.037L0 28.1018Z",
    fill: "#BAEEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.05 42.3173H13.77C13.2177 42.3173 12.77 42.764 12.77 43.3149V123.54C12.77 124.091 13.2177 124.538 13.77 124.538H68.05C68.6023 124.538 69.05 124.091 69.05 123.54V43.3149C69.05 42.764 68.6023 42.3173 68.05 42.3173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.81 42.3173H80.34C79.7877 42.3173 79.34 42.764 79.34 43.3149V76.9333C79.34 77.4843 79.7877 77.9309 80.34 77.9309H163.81C164.362 77.9309 164.81 77.4843 164.81 76.9333V43.3149C164.81 42.764 164.362 42.3173 163.81 42.3173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.81 87.9965H80.34C79.7877 87.9965 79.34 88.4431 79.34 88.994V123.49C79.34 124.041 79.7877 124.488 80.34 124.488H163.81C164.362 124.488 164.81 124.041 164.81 123.49V88.994C164.81 88.4431 164.362 87.9965 163.81 87.9965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30.6157H178V20.9491C178 19.5081 177.715 18.0812 177.163 16.7498C176.61 15.4185 175.8 14.2088 174.778 13.1898C173.757 12.1708 172.544 11.3625 171.21 10.8111C169.875 10.2596 168.445 9.97577 167 9.97577H11C8.08262 9.97577 5.28473 11.1319 3.22183 13.1898C1.15893 15.2477 0 18.0388 0 20.9491L0 30.6157Z",
    fill: "url(#paint0_linear_709_97894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 112.647C104.019 112.647 117.75 98.9485 117.75 82.0509C117.75 65.1533 104.019 51.4551 87.08 51.4551C70.1414 51.4551 56.41 65.1533 56.41 82.0509C56.41 98.9485 70.1414 112.647 87.08 112.647Z",
    fill: "url(#paint1_linear_709_97894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0956 95.0639C96.7671 97.3868 93.8003 98.9687 90.5705 99.6096C87.3407 100.251 83.993 99.9216 80.9506 98.6644C77.9082 97.4073 75.3078 95.2784 73.4783 92.5469C71.6488 89.8155 70.6723 86.6042 70.6723 83.3191C70.6723 80.034 71.6488 76.8227 73.4783 74.0912C75.3078 71.3598 77.9082 69.2309 80.9506 67.9737C83.993 66.7166 87.3407 66.3876 90.5705 67.0285C93.8003 67.6694 96.7671 69.2513 99.0956 71.5742",
    stroke: "white",
    strokeWidth: 3.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6914 64.1607L99.0945 71.5744L91.3658 73.3308",
    stroke: "white",
    strokeWidth: 3.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.23 22.8944C11.6659 22.8944 12.83 21.7332 12.83 20.3007C12.83 18.8683 11.6659 17.707 10.23 17.707C8.79406 17.707 7.63 18.8683 7.63 20.3007C7.63 21.7332 8.79406 22.8944 10.23 22.8944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 22.8944C22.6359 22.8944 23.8 21.7332 23.8 20.3007C23.8 18.8683 22.6359 17.707 21.2 17.707C19.7641 17.707 18.6 18.8683 18.6 20.3007C18.6 21.7332 19.7641 22.8944 21.2 22.8944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.17 22.8944C33.6059 22.8944 34.77 21.7332 34.77 20.3007C34.77 18.8683 33.6059 17.707 32.17 17.707C30.7341 17.707 29.57 18.8683 29.57 20.3007C29.57 21.7332 30.7341 22.8944 32.17 22.8944Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_709_97894",
    x1: -8.44441,
    y1: 25.844,
    x2: 2.91645,
    y2: -29.0252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72B6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_709_97894",
    x1: 53.5,
    y1: 98.5,
    x2: 125.915,
    y2: 57.8478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2496FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31ECE1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_97894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.2d2e7f7c938305ae32b0ca74b36eebda.svg";
export { ForwardRef as ReactComponent };